import { AttachFile } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { CollaborationRequestAPI } from '../../../../api/collaboration/collaborationRequest';
import Alert from '../../../../components/Alert/Alert';

const ExternalInfluencerModal = ({ externalInfluencer, open, setOpen }) => {

    const intl = useIntl();
    const [description, setDescription] = useState('');
    const [showModalConfirmation, setShowModalConfirmation] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        setDescription('');
        setFile(null);
    }, [externalInfluencer]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleFileUpload = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile) {
            setFile(uploadedFile);
            console.log('Archivo seleccionado:', uploadedFile);
        }
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const sendCollaborationRequest = () => {
        CollaborationRequestAPI.saveCollaborationRequest(externalInfluencer, description).then(() => {
            setOpen(false);
            setShowModalConfirmation(true);
            setDescription('');
            setFile(null);
        }).catch(() => {
            setShowModalError(true);
        });
    };

    const getSocialNetworkLink = () => {
        if (externalInfluencer?.social_network === "instagram") {
            return `https://www.instagram.com/${externalInfluencer.username}`;
        } else if (externalInfluencer?.social_network === "tiktok") {
            return `https://www.tiktok.com/@${externalInfluencer.username}`;
        } else if (externalInfluencer?.social_network === "YouTube") {
            return `https://www.youtube.com/channel/${externalInfluencer?.username}`;
        } else {
            return "#";
        }
    }

    return (
        <>
            <Dialog id="fl-dialog-container" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <div className='p-3 pt-1' style={{ minWidth: '22vw' }}>
                    <DialogTitle id="fl-dialog-title">
                        <div>
                            <h3 className='fl-text-primary'>
                                <FormattedMessage id="externalInfluencersModalTitle" />
                            </h3>
                        </div>
                    </DialogTitle>
                    <DialogContent className='pb-2'>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1em' }}>
                            <a href={getSocialNetworkLink()} target="_blank" rel="noreferrer" className='text-dark d-flex align-items-center'>
                                <img
                                    src={externalInfluencer?.image_profile}
                                    alt={externalInfluencer?.username}
                                    style={{
                                        borderRadius: '50%',
                                        width: '50px',
                                        height: '50px',
                                        marginRight: '1em',
                                    }}
                                />
                                <span style={{ fontWeight: 600 }}>{externalInfluencer?.username}</span>
                            </a>
                        </div>
                        <TextField
                            placeholder={intl.formatMessage({ id: 'externalInfluencersModalPlaceholder' })}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            autoFocus
                            maxRows={8}
                            margin="dense"
                            id="fl-input"
                            size="small"
                            multiline
                            variant="standard"
                            fullWidth
                            required
                        />
                    </DialogContent>
                    <DialogActions className='p-2 pt-1'>
                        <IconButton onClick={handleClick}>
                            <AttachFile />
                        </IconButton>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            accept=".doc,.docx,.pdf"
                            onChange={handleFileUpload}
                        />
                        <button onClick={handleClose} className="fl-button-secondary">
                            <FormattedMessage id="externalInfluencersModalButtonCancel" />
                        </button>
                        <button onClick={() => sendCollaborationRequest()} className="fl-button-primary">
                            &nbsp;&nbsp;
                            <FormattedMessage id="externalInfluencersModalButtonSend" />&nbsp;&nbsp;
                        </button>
                    </DialogActions>
                </div>
            </Dialog>

            {
                showModalConfirmation && (
                    <Alert
                        title={
                        <FormattedMessage
                            id="externalInfluencersModalSuccessTitle"
                        />
                        }
                        text={
                        <Typography textAlign={'center'}>
                            <FormattedMessage
                            id="externalInfluencersModalSuccessText"
                            />
                        </Typography>
                        }
                        confirmText={
                        <FormattedMessage
                            id="externalInfluencersModalButtonClose"
                        />
                        }
                        onConfirm={() => setShowModalConfirmation(false)}
                        setShowAlert={setShowModalConfirmation}
                    />
                )
            }
            {
                showModalError && (
                    <Alert
                        title={
                        <FormattedMessage
                            id="externalInfluencersModalErrorTitle"
                        />
                        }
                        text={
                        <Typography textAlign={'center'}>
                            <FormattedMessage
                            id="externalInfluencersModalErrorText"
                            />
                        </Typography>
                        }
                        confirmText={
                        <FormattedMessage
                            id="externalInfluencersModalButtonClose"
                        />
                        }
                        onConfirm={() => setShowModalError(false)}
                        setShowAlert={setShowModalError}
                    />
                )
            }

        </>
    );
}

export default ExternalInfluencerModal;
